import { COLORS2 } from '../../Styles';

export const GroupLabelTagIcon = ({
  size = 13,
}: {
  size?: number;
}) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 13 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden
    style={{ display: 'inline-flex', flexShrink: 0 }}
  >
    <path
      d='M4.84396 0.921758C5.26158 0.504132 5.81787 0.255046 6.40773 0.221463L10.2386 0.00392067C11.6725 -0.0774428 12.8573 1.10738 12.7759 2.54122L12.5583 6.37208C12.5247 6.96199 12.2756 7.51827 11.8581 7.93585L7.71836 12.0755C6.77933 13.0146 5.25661 13.0146 4.31758 12.0755L0.704262 8.46223C-0.234766 7.5232 -0.234766 6.00048 0.704262 5.06145L4.84396 0.921758ZM5.16778 11.2254C5.6373 11.6949 6.39864 11.6949 6.86816 11.2254L11.0079 7.08566C11.2163 6.87727 11.3412 6.5987 11.3578 6.30397L11.5754 2.4731C11.6165 1.75617 11.0237 1.16336 10.3067 1.2044L6.4758 1.42195C6.18106 1.43855 5.9025 1.56351 5.69411 1.77191L1.55441 5.91161C1.08489 6.38112 1.08489 7.14247 1.55441 7.61199L5.16778 11.2254Z'
      fill={COLORS2.alwaysDark.green}
    />
  </svg>
);
